import { FC } from 'react';

import DatesSection from './DatesSection';
import ScriptureDataSection from './ScriptureDataSection';
import CoOwnersSection from './CoOwnersSection';

const EncumbranceDetailsPageBody: FC = () => (
  <div className="encumbrance-details-page-body">
    <DatesSection />

    <ScriptureDataSection />

    <CoOwnersSection />
  </div>
);
export default EncumbranceDetailsPageBody;
